import type { IconNames } from '@codametrix/ui-components';

/**
 * Note-type -> verdigris/ui-components icon name lookup. `CMxAPI.Note.type` carries
 * `DocumentMetadata.documentType`, the same document-category vocabulary
 * `notes-sidebar/notes-navbarv2.tsx`'s own `DocCategories` map already keys on (DFT/DFT_IN/DFT_OUT/
 * DFT_EHR/HL7/NTE/NOTE) -- reused here so a DFT-family note and an HL7 note get visually distinct
 * icons, matching that existing convention rather than inventing a new one. Every OTHER/unknown
 * type (including the common case of a plain clinical note with no distinct category) falls back to
 * `DEFAULT_NOTE_ICON`, a generic document/report icon -- `iconForNoteType` never throws and never
 * returns `undefined`.
 */
const NOTE_TYPE_ICON: Readonly<Record<string, IconNames>> = {
  DFT: 'BiomeDFT',
  DFT_IN: 'BiomeDFT',
  DFT_OUT: 'BiomeDFT',
  DFT_EHR: 'BiomeDFT',
  HL7: 'BiomeADT',
  NTE: 'BiomeEditNote',
  NOTE: 'BiomeEditNote'
};

/** Generic clinical-note/report icon -- the fallback for every type not in `NOTE_TYPE_ICON`
 *  (including `null`/`undefined`). */
export const DEFAULT_NOTE_ICON: IconNames = 'BiomeReports';

export function iconForNoteType(type: string | null | undefined): IconNames {
  if (type == null) {
    return DEFAULT_NOTE_ICON;
  }
  return Object.hasOwn(NOTE_TYPE_ICON, type)
    ? NOTE_TYPE_ICON[type]
    : DEFAULT_NOTE_ICON;
}
